import { useQuery } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@shared/services/api';

import { CoinRaceDetailedResponse } from '@types';

const COIN_RACE_DETAILS_URL = '/coin_races';

export const GET_COIN_RACE_DETAILS_QUERY_KEY = 'coinRaceDetails';

type UseQueryCoinRaceDetailsProps = {
	id: string;
	page?: number;
	per_page?: number;
};

export const useQueryCoinRaceDetails = ({ id, page = 1, per_page = 100 }: UseQueryCoinRaceDetailsProps) => {
	return useQuery<unknown, unknown, CoinRaceDetailedResponse>({
		queryKey: [GET_COIN_RACE_DETAILS_QUERY_KEY, id, page, per_page],
		queryFn: () => {
			return request<CoinRaceDetailedResponse>({
				method: 'get',
				url: getUrlToBackendApi(`${COIN_RACE_DETAILS_URL}/${id}?page=${page}&per_page=${per_page}`).href
			});
		},
		retry: false
	});
};

